import { LoginState } from "../types/types";
import {
  DEVICE_MANAGEMENT_DATA_FAILURE,
  DEVICE_MANAGEMENT_DATA_REQUEST,
  DEVICE_MANAGEMENT_DATA_SUCCESS,
  RELOAD_DETAILS_PAGE,
  DELETE_DETAILS_PAGE_DATA,
  FIRST_TIME_USER_RESET_PWD
} from "./actionTypes";
// import { Notification } from "../../src/components/notification/notification";
// import { BroadcastChannelHandler } from "../components/broadcastChannel/BroadcastChannelHandler";

const initState: LoginState = {
  login: {
    loading: false,
    data: null,
  },
  logout: {
    loading: false,
    data: null,
  },
  deviceManagement: {
    data: null,
    loading: false
  }
};

export default (state = initState, action: { type: string; payload: any }) => {
  switch (action.type) {

    case FIRST_TIME_USER_RESET_PWD:
      return {
        ...state,
        login: {
          data: action.payload,
          loading: false,
        },
      };

    case DEVICE_MANAGEMENT_DATA_REQUEST:
      return {
        ...state,
        deviceManagement: {
          data: null,
          loading: true,
        },
      };

    case DEVICE_MANAGEMENT_DATA_SUCCESS:
      return {
        ...state,
        deviceManagement: {
          data: action.payload,
          loading: false,
        },
      };
    case DEVICE_MANAGEMENT_DATA_FAILURE:
      return {
        ...state,
        deviceManagement: {
          data: action.payload,
          loading: false,
        },
      };

    case RELOAD_DETAILS_PAGE:

      return {
        ...state,
        reloadDetailsPage: {
          data: action.payload,
          loading: false,
        },
      }

    case DELETE_DETAILS_PAGE_DATA:

      return {
        ...state,
        reloadDetailsPage: null,
      }


    default:
      return {
        ...state,
      };
  }
};
